<template>
  <div v-if="isWelcomeLogin">
    <div class="pt24 plr16 fs-14 bold">
      {{ loginProps?.subHeadingText }}
    </div>
    <div class="mobile-number-container" :class="{ 'border-red': loginError }">
      <div class="country-code">+91</div>
      <input
        class="mobile-number-input"
        id="mobileNumberInput"
        type="text"
        name="mobileNoInput"
        placeholder="Enter your mobile no."
        inputmode="numeric"
        maxlength="10"
        autocomplete
        autofocus
        v-model="mobileNo"
        @keyup.enter="handleEnterKeyPress"
        @input="
          (event) => (mobileNo = event.target.value.replace(/[^\d]+/g, ''))
        "
      />
    </div>
    <div class="sending-otp-message" v-if="showSendingOtp && !loginError">
      {{ loginProps?.sendingOtpText }}
      <div class="loading-sm"></div>
    </div>
    <div class="validation-message color-error" v-else-if="loginError">
      {{ loginError }}
    </div>
    <div
      class="validation-message"
      v-else-if="!showSendingOtp && !disableSendOtp"
    >
      {{ loginProps?.infoTextBelowNumberInput2 }}
    </div>
    <div class="validation-message" v-else-if="!loginError">
      {{ loginProps?.infoTextBelowNumberInput }}
    </div>
    <div class="footer-login plr16" :class="{ pb16: clientPlatform == 'Web' }">
      <div class="terms-label">
        {{ loginProps?.tncStartText }}
        <span class="tnc" @click="handleTnCCTA($event)">{{
          loginProps?.tncEndText
        }}</span>
      </div>
      <button
        class="send-otp-button bold hand"
        :disabled="disableSendOtp || disableOtp"
        @click="handleSendOtp($event)"
      >
        <span :class="{ 'color-white': disableSendOtp || disableOtp }">{{
          loginProps?.sendOtpButtonText
        }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { LoginStates } from "../helpers/loginStateConstants";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import fingerPrintInstance from "../store/storeInitializer/initialiseFingerprint";
import { collectData } from "../helpers/fingerPrintHelper";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { LoginStateStatus } from "../helpers/loginStateConstants";
import Utility from "../helpers/utility";
import {
  EVENT_CLICK_SENDOTP,
  EVENT_TYPE_MOBILENUMBER,
} from "../helpers/analyticsEvents";

export default {
  name: "WelcomeLogin",
  components: {
    GenericModal,
  },
  props: ["moduleProps", "propsData"],
  data() {
    return {
      modulePropsData: {},
      clientPlatform,
      staticImgBaseUrl: staticImgBaseUrl,
      mobileNo: LocalStorageFunc.getUserMobileNo() || "",
      mobileNumberEnterEventProcessed: false,
      disableOtp: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : this.propsData || {};
  },
  watch: {
    mobileNo(newVal, oldVal) {
      if (
        (oldVal.length === 10 && newVal.length === 9) ||
        newVal.length === 10
      ) {
        this.disableOtp = false;
      } else if (newVal.length !== 10) {
        this.disableOtp = true;
      }
    },
  },
  methods: {
    handleSendOtp(e) {
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_CURRENT_LOGIN_STATE,
      //   LoginStates.otpVerification
      // );
      if (this.loginError) {
        this.$store.commit(keyMapsMutation.UPDATE_LOGIN_ERROR, "");
      }
      this.$store.commit(keyMapsMutation.UPDATE_LOCAL_STORAGE_USER_DATA, {
        mobile: this.mobileNo,
      });
      EVENT_CLICK_SENDOTP({ loginMethod: "manual" });
      this.$store.dispatch(keyMapsAction.FORGOT_PASSWORD_API, {
        mobile: this.mobileNo,
        hash: this.hashKey?.key,
        id: this.hashKey?.id,
      });
    },
    handleEnterKeyPress(e) {
      if (!this.disableSendOtp && !this.disableOtp) {
        this.handleSendOtp(e);
      }
    },
    handleTnCCTA(e) {
      Utility.sendToTnC();
    },
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD,
        false
      );
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    showWelcomeLoginModal() {
      return this.$store.state.Auth.showWelcomeScreenOnPageLoad;
    },
    // HOK - 839 fixes, now back button will always be displayed
    // showBackButton() {
    //   return this.mobileNo.length > 0;
    // },
    disableSendOtp() {
      if (
        this.mobileNo?.length > 0 &&
        this.mobileNo?.length != 10 &&
        !this.mobileNumberEnterEventProcessed
      ) {
        this.mobileNumberEnterEventProcessed = true;
        EVENT_TYPE_MOBILENUMBER({ loginMethod: "manual" });
      }
      return (
        this.mobileNo.length != 10 ||
        this.$store.state.Auth.loginStateStatus == LoginStateStatus.SENDING_OTP
      );
    },
    showSendingOtp() {
      return (
        this.$store.state.Auth.loginStateStatus == LoginStateStatus.SENDING_OTP
      );
    },
    hashKey() {
      return this.$store.state.FingerPrint.hashKey;
    },
    isWelcomeLogin() {
      this.mobileNo = LocalStorageFunc.getUserMobileNo() || "";

      return clientPlatform == "Web"
        ? this.$store.state.Auth.currentLoginState ===
            LoginStates.welcomeLogin &&
            this.$store.state.Auth.showProfileDrawerModal
        : this.$store.state.Auth.currentLoginState === LoginStates.welcomeLogin;
    },
    loginProps() {
      return Object.keys(this.modulePropsData).length
        ? this.modulePropsData
        : this.$store.state.Auth.loginProps;
    },
    loginError() {
      if (this.$store.state.Auth.loginError) {
        const { getFPInstance } = fingerPrintInstance;
        collectData({ detector: getFPInstance() }).then((response) => {
          const payload = {
            detectorData: response,
          };
          this.$store.dispatch(keyMapsAction.SEND_FINGER_PRINT, payload);
        });
        this.disableOtp = true;
      }
      return this.$store.state.Auth.loginError;
    },
  },
};
</script>
